import { render, staticRenderFns } from "./MaturityAssessment.vue?vue&type=template&id=52d23218&"
import script from "./MaturityAssessment.vue?vue&type=script&lang=js&"
export * from "./MaturityAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports